import React from 'react';
import { StyledCardTitle } from './styled';

const CardTitle: React.FC = ({ children }) => {
  return <StyledCardTitle>{children}</StyledCardTitle>;
};


export default CardTitle;
